import { Component, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ListaItem } from '../../_models/lista-item';
import { ExcepcionGMF } from '../../_models/excepcion-gmf';
import { ExcepcionGmfService } from '../../_services/excepcion-gmf.service';

@Component( {
  selector: 'app-excepciones-gmf-editar',
  templateUrl: 'excepciones-gmf-editar.component.html'
} )

export class ExcepcionesGmfEditarComponent implements OnInit {
  carInformacionInicial = true;
  excepcionGmf: ExcepcionGMF;
  acordion: number;
  busqueda: string;
  columnas: any[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  tabSeleccionado = 'GENERAL';
  todasExcepcionesGmf: ExcepcionGMF [] = [];
  idEstructuraFisica: number;


  constructor( private location: Location,
               private confirmationService: ConfirmationService,
               private excepcionGmfServicio: ExcepcionGmfService,
               private navService: NavService,
               private conServicio: ConfirmationService,
               private fb: FormBuilder,
               private route: ActivatedRoute ) {

  }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
        if ( params['id'] !== '' && params['id'] !== null && params['id'] !== undefined ) {
          this.excepcionGmfServicio.obtenerPorId(params['id']).subscribe( excep => {
            this.excepcionGmf = excep;
            this.cargarFormulario();
            this.cargarServicios();
          });
        } else {
          this.cargarFormulario();
          this.cargarServicios();
        }
    });

  }

  onSubmit() {
    this.submitted = true;
    /**validación campos formulario*/
    if ( this.formulario.valid ) {
      /**confirmación para guardar el registro*/
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_GUARDAR'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          // Guardar - actualizar excepcion
          const datosExcepcion = this.formulario.value;
          this.guardando = true;
          this.guardarExcepcionGmf( datosExcepcion );
        },
        reject: () => {
        }
      });
    }
  }

  guardarExcepcionGmf( excepcionGmf: ExcepcionGMF ) {

    if ( excepcionGmf.idExcepcionGMF !== '' && excepcionGmf.idExcepcionGMF !== null && excepcionGmf.idExcepcionGMF !== undefined) {

      if ( ( this.todasExcepcionesGmf.find( x => x.codigo === excepcionGmf.codigo &&
        x.idExcepcionGMF !== excepcionGmf.idExcepcionGMF ) ) !== undefined) {
        this.navService.setMesage(0, {
          severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
          detail: this.navService.buscarMensaje('EXCEPCIONESGMF.MSG_CODIGOENUSO')
        });
        this.guardando = false;
      } else {
        this.excepcionGmfServicio.actualizar( excepcionGmf ).subscribe(rta => {
          this.excepcionGmf = rta;
          this.cargarFormulario();
          this.cargarServicios();
          this.tabSeleccionado = 'CONFIGDESTINOS';
          this.guardando = false;
          this.navService.setMesage(2);
        }, error => {
          this.navService.setMesage(3);
          this.guardando = false;
        });
      }
    } else {

      if ( ( this.todasExcepcionesGmf.find( x => x.codigo === excepcionGmf.codigo  ) ) !== undefined) {
        this.navService.setMesage(0, {
          severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
          detail: this.navService.buscarMensaje('EXCEPCIONESGMF.MSG_CODIGOENUSO')
        });
        this.guardando = false;
      } else {
        this.excepcionGmfServicio.crear( excepcionGmf ).subscribe(rta => {
          this.excepcionGmf = rta;
          this.cargarFormulario();
          this.cargarServicios();
          this.tabSeleccionado = 'CONFIGDESTINOS';
          this.navService.setMesage(1);
          this.guardando = false;
        }, error => {
          this.navService.setMesage(3);
          this.guardando = false;
        });
      }
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  cargarServicios() {
    this.excepcionGmfServicio.listado().subscribe(
      res => {
        this.todasExcepcionesGmf = res;
        this.carInformacionInicial = false;
      }
    );
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idExcepcionGMF: this.excepcionGmf ? this.excepcionGmf.idExcepcionGMF : null,
      indicadorManejaCtaAhorros: this.excepcionGmf ? this.excepcionGmf.indicadorManejaCtaAhorros : false,
      codigo: [this.excepcionGmf ? this.excepcionGmf.codigo : null, [Validators.required, Validators.maxLength(10)]],
      nombre: [this.excepcionGmf ? this.excepcionGmf.nombre : null, [Validators.required, Validators.maxLength(50)]],
      descripcion: [this.excepcionGmf ? this.excepcionGmf.descripcion : null, [Validators.required, Validators.maxLength(500)]],
      indicadorHabilitado: [ this.excepcionGmf ? this.excepcionGmf.indicadorHabilitado : true ]
    });
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'GENERAL';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CONFIGDESTINOS';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'CONFIGDESTINOSEXCENTOS';
      }
      break;
      default: {
        break;
      }
    }
  }
}
